"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var confirmationMessageStyles_1 = require("./confirmationMessageStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var NameplateOEMCodes_1 = require("../../../../../common/enum/NameplateOEMCodes");
var react_intl_1 = require("react-intl");
var useDealData_1 = require("../../../common/hooks/useDealData");
var ContinueInDealershipMessage = function () {
    var _a;
    var styles = confirmationMessageStyles_1.default();
    var _b = core_1.useTheme().checkoutLite.confirmation, showConfirmationTitle = _b.showConfirmationTitle, useCustomDescription = _b.useCustomDescription;
    var intl = react_intl_1.useIntl();
    var dealData = useDealData_1.default().dealData;
    var oemCode = (_a = dealData) === null || _a === void 0 ? void 0 : _a.car.nameplate.attributes.oemcode;
    return (<core_1.Box className={styles.container} data-test={'container:confirmation_continue_in_dealer:message'}>
      {!!showConfirmationTitle && (<core_1.Typography variant={'h4'} className={styles.title} data-test="text:confirmation:title">
          <Translation_1.default id={'trans__checkout__confirmation_page__title_enquiry_journey'}/>
        </core_1.Typography>)}
      <core_1.Typography variant={'body1'} className={styles.description1} data-test="text:confirmation:description1">
        <Translation_1.default id={useCustomDescription && oemCode === NameplateOEMCodes_1.NameplateOEMCodes.PASSENGER
        ? 'trans__checkout__confirmation_page__description1__vehicletype2'
        : 'trans__checkout__confirmation_page__description1'} values={{
        email: (<a className={styles.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__confirmation_page__email_on_description_enquiry_journey',
        })}>
                <Translation_1.default id={'trans__checkout__confirmation_page__email_on_description_enquiry_journey'}/>
              </a>),
    }}/>
      </core_1.Typography>
      <core_1.Typography variant={'body1'} className={styles.description2} data-test="text:confirmation:description2">
        <Translation_1.default id={'trans__checkout__confirmation_page__description2_enquiry_journey'}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = ContinueInDealershipMessage;
